export const adminResources = {
  lessons: {
    table: 'lessons',
    title: 'Lessons',
    idColumn: 'id',
    onConflict: 'module_id,lesson_number',
    listOrder: { column: 'lesson_number', ascending: true },
    columnsHint: ['module_id','lesson_number','title','difficulty','scenario_context','initial_objection','buyer_persona','overview','success_criteria'],
    newTemplate: {
      module_id: 'lumo_core',
      lesson_number: 1,
      title: '',
      scenario_context: '',
      initial_objection: '',
      buyer_persona: '',
      difficulty: 2,
      success_criteria: '',
      overview: '',
      scenario_setup: '',
      learning_objectives: '',
      trainer_breakdown_why_it_matters: '',
      trainer_breakdown_what_good_looks_like: '',
      trainer_breakdown_what_bad_looks_like: '',
      trainer_breakdown_phrases_to_use: '',
      trainer_breakdown_mistakes_to_avoid: '',
      practice_drill: '',
      scoring_rubric: '',
      reflection_questions: ''
    }
  },
  trainer_scenarios: {
    table: 'trainer_scenarios',
    title: 'Trainer Scenarios',
    idColumn: 'id',
    onConflict: 'module_id,lesson_number',
    listOrder: { column: 'lesson_number', ascending: true },
    columnsHint: ['module_id','lesson_number','title','scenario_context','initial_objection','buyer_persona','difficulty','success_criteria'],
    newTemplate: {
      module_id: 'lumo_core',
      lesson_number: 1,
      title: '',
      scenario_context: '',
      initial_objection: '',
      buyer_persona: '',
      difficulty: 2,
      success_criteria: ''
    }
  },
  drills: {
    table: 'drills',
    title: 'Drills',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['industry','type','title','prompt_text','difficulty_level','tags'],
    newTemplate: {
      industry: 'Global',
      type: 'General',
      title: '',
      prompt_text: '',
      difficulty_level: 2,
      tags: null
    }
  },
  objections: {
    table: 'objections',
    title: 'Objections',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'difficulty', ascending: true },
    // schema varies; admin UI will adapt to whatever columns exist
    columnsHint: ['label','industry','difficulty','category_id','script','notes'],
    newTemplate: {
      label: '',
      industry: 'global',
      difficulty: 2,
      category_id: null,
      script: '',
      notes: ''
    }
  },
  coaching_concepts: {
    table: 'coaching_concepts',
    title: 'Coaching Concepts',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['title','category','content_md','difficulty'],
    newTemplate: {
      title: '',
      category: 'general',
      content_md: '',
      difficulty: 2
    }
  },
  objection_stacks: {
    table: 'objection_stacks',
    title: 'Objection Stacks',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['name','industry','stack_json','notes'],
    newTemplate: {
      name: '',
      industry: 'global',
      stack_json: '[]',
      notes: ''
    }
  },
  objection_persona_strategies: {
    table: 'objection_persona_strategies',
    title: 'Persona Strategies',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['objection_id','persona','strategy_md','difficulty'],
    newTemplate: {
      objection_id: null,
      persona: 'CFO',
      strategy_md: '',
      difficulty: 2
    }
  },
  objection_root_causes: {
    table: 'objection_root_causes',
    title: 'Objection Root Causes',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['label','description_md','resolution_md','severity'],
    newTemplate: {
      label: '',
      description_md: '',
      resolution_md: '',
      severity: 2
    }
  },
  script_library: {
    table: 'script_library',
    title: 'Script Library',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['industry','script_type','goal','title','template_text','coaching_notes'],
    newTemplate: {
      industry: 'global',
      script_type: '',
      goal: 'general',
      title: '',
      template_text: '',
      coaching_notes: ''
    }
  },
  script_blocks: {
    table: 'script_blocks',
    title: 'Script Blocks',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['industry','script_type','goal','block_type','content_md','order_index'],
    newTemplate: {
      industry: 'global',
      script_type: '',
      goal: 'general',
      block_type: 'intro',
      content_md: '',
      order_index: 1
    }
  },
  script_knowledge_cache: {
    table: 'script_knowledge_cache',
    title: 'Script Knowledge Cache',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['script_type','industry','scenario_text','generated_script','tone_notes','ai_model','tags'],
    newTemplate: {
      script_type: '',
      industry: 'global',
      scenario_text: '',
      generated_script: '',
      tone_notes: '[]',
      ai_model: 'gpt-4o-mini',
      tags: '["admin"]'
    }
  },
  uploaded_materials: {
    table: 'uploaded_materials',
    title: 'Uploaded Materials',
    idColumn: 'id',
    onConflict: 'id',
    listOrder: { column: 'created_at', ascending: false },
    columnsHint: ['team_id','uploader_id','file_name','file_type','processing_status','file_size','description','tags','parsed_content','evaluation_results'],
    newTemplate: null
  }
};
